import React from 'react';
import PropTypes from 'prop-types';

const FollowCall = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12.68 12.679" {...other}>
      <path id="パス_3700" data-name="パス 3700" d="M9.753,12.745a5.773,5.773,0,0,1-1.991-.438A11.153,11.153,0,0,1,3.9,9.877,13.838,13.838,0,0,1,.832,5.855a4.965,4.965,0,0,1-.757-2.23A3.824,3.824,0,0,1,.872.8,1.769,1.769,0,0,1,2.5.08a.811.811,0,0,1,.637.358,1.4,1.4,0,0,1,.2.319c.239.717.6,1.394.836,2.111l.119.478a.978.978,0,0,1-.319.836l-.4.4a1.036,1.036,0,0,0-.159,1.155,2.365,2.365,0,0,0,.159.319A9.916,9.916,0,0,0,5.89,8.563a8.614,8.614,0,0,0,1.434.876,1.272,1.272,0,0,0,.558.119,1.1,1.1,0,0,0,.6-.319,4.135,4.135,0,0,0,.478-.677c.08-.08.119-.2.2-.279a.739.739,0,0,1,.876-.239,4.316,4.316,0,0,1,.757.319c.4.2.8.438,1.195.637.08.04.119.08.2.119a1.03,1.03,0,0,1,.518,1.235,2.549,2.549,0,0,1-.518,1.314,2.94,2.94,0,0,1-1.752,1.036A3.644,3.644,0,0,1,9.753,12.745Z" transform="translate(-0.058 -0.066)" fill={color} />
    </svg>
  );
}

FollowCall.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

FollowCall.defaultProps = {
  color: '#000000',
  width: 22,
  height: 22,
};

export default FollowCall;



// WEBPACK FOOTER //
// ./src/components/Icons/FollowCall.jsx